import { createDisplayNumberFormat } from './displayNumberFormat';
import i18n from 'i18next';
import { displayDigits } from './displayDigits';

/** Workout values use a dot decimal separator while retaining localized digits. */
export function workoutDisplayDigits(value: string | number, locale = i18n.resolvedLanguage ?? i18n.language): string {
  return displayDigits(value, locale).replace(/٫/g, '.');
}

export function formatWorkoutNumber(value: number, locale = i18n.resolvedLanguage ?? i18n.language, options: Intl.NumberFormatOptions = {}): string {
  const parts = createDisplayNumberFormat(locale || 'en', options).formatToParts(value);
  // A locale that groups with dots must not make 1,234.5 ambiguous as 1.234.5.
  const text = parts.map(part => part.type === 'decimal' ? '.' : part.type === 'group' && part.value === '.' ? ',' : part.value).join('');
  return workoutDisplayDigits(text, locale);
}
